import styles from './LoadingScreen.module.css'

export function LoadingScreen() {
  return (
    <main className={styles.root} aria-live="polite" aria-busy="true">
      <div className="container">
        <div className={styles.heroSkeleton}>
          <div className={styles.shimmerBlock} />
          <div className={styles.heroGrid}>
            <div className={styles.heroColumn}>
              <div className={`${styles.shimmerLine} ${styles.short}`} />
              <div className={`${styles.shimmerLine} ${styles.title}`} />
              <div className={`${styles.shimmerLine} ${styles.medium}`} />
              <div className={`${styles.shimmerLine} ${styles.long}`} />
            </div>
            <div className={styles.statsColumn}>
              <div className={styles.statCard} />
              <div className={styles.statCard} />
              <div className={styles.statCard} />
            </div>
          </div>
        </div>

        <div className={styles.tabSkeleton}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={styles.tabPill} />
          ))}
        </div>

        <div className={styles.cardGrid}>
          <div className={styles.card} />
          <div className={styles.card} />
          <div className={styles.cardTall} />
        </div>
      </div>
    </main>
  )
}
